import React, { useState } from 'react';

// TODO make this not default to a value in some cases.
// TODO make this clearable
const DateInput = ({ label, value, name, state, minDate, maxDate, onChange, datesAllowed, innerRef, ...rest}) => {

    if (state && name !== undefined) {
        value = state[name];
    }

    if (name === undefined){
        console.error(`name is undefined for date input label: ${label}`);
        name = "UNDEFINED!"
        value = new Date().toISOString().split("T")[0];
        onChange = (e) => {
            console.error(`name is undefined for date input cannot store value! label: ${label}`)
        }
    }

    return (
        <div className={'form-input-area__input'}>
            <label>
                {label}
                <input type="date"
                       name={name}
                       value={value}
                       onChange={onChange}
                       min={minDate}
                       max={maxDate}
                       ref={innerRef}
                       {...rest}
                />
            </label>
        </div>
    );
}

export default DateInput;